<template>
    <div class="topbar">
        <img src="../assets/images/logo-white.png">
        <h2>APEX ToolBox</h2>
        <span>{{user}}</span>
    </div>
</template>
<script>
    import api from "../request/api";

    export default {
        name: "TopBar",
        date() {
            return {
                user: "",
            };
        },
        created() {
            api.get("/apextb/users/current").then(
                (response) => {
                    this.user = response.data.userAccount;
                },
                (error) => {
                    console.log(error.message);
                }
            );
        },
    };
</script>
<style  scoped>
    .topbar {
        display: flex;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #000;
        border-radius: 8px;
    }
    .topbar img {
        margin: auto 20px;
        height: 35px;
    }
    .topbar h2 {
        font-size: 26px;
        color: #fff;
    }
    .topbar span {
        margin-left: auto;
        color: #fff;
    }
</style>